import { render } from "./reportealertas.vue?vue&type=template&id=4a6c75aa"
import script from "./reportealertas.vue?vue&type=script&lang=js"
export * from "./reportealertas.vue?vue&type=script&lang=js"

import "./reportealertas.vue?vue&type=style&index=0&id=4a6c75aa&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__